import React from "react";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export const EmptyState = ({ icon: Icon = Sparkles, title, description, action, actionLabel, secondaryAction, secondaryLabel }) => (
  <div data-testid="empty-state" className="flex flex-col items-center justify-center text-center py-16 px-6">
    <div className="h-14 w-14 rounded-2xl aurelo-gradient flex items-center justify-center mb-4 shadow-[0_10px_24px_rgba(59,130,246,0.18)]">
      <Icon className="h-7 w-7 text-white" />
    </div>
    <h3 className="text-base font-semibold text-slate-900">{title}</h3>
    {description && <p className="text-sm text-slate-500 mt-1 max-w-sm">{description}</p>}
    <div className="flex items-center gap-2 mt-5">
      {action && <Button data-testid="empty-state-primary-cta" onClick={action} className="aurelo-gradient text-white">{actionLabel}</Button>}
      {secondaryAction && <Button variant="outline" onClick={secondaryAction}>{secondaryLabel}</Button>}
    </div>
  </div>
);

export const LoadingSkeleton = ({ rows = 6 }) => (
  <div className="space-y-3 animate-pulse">
    <div className="grid grid-cols-4 gap-3">
      {[0, 1, 2, 3].map((i) => <div key={i} className="h-24 rounded-xl bg-slate-100" />)}
    </div>
    <div className="h-8 rounded-lg bg-slate-100 w-1/3" />
    {Array.from({ length: rows }).map((_, i) => <div key={i} className="h-12 rounded-lg bg-slate-100" />)}
  </div>
);

export const PageHeader = ({ title, subtitle, actions, icon: Icon }) => (
  <div className="flex items-start justify-between gap-4 mb-6">
    <div className="flex items-center gap-3">
      {Icon && <div className="h-10 w-10 rounded-xl bg-white border border-slate-200 flex items-center justify-center shadow-sm"><Icon className="h-5 w-5 text-[#7C3AED]" /></div>}
      <div>
        <h1 className="text-xl font-bold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
    </div>
    {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
  </div>
);
